// @ts-ignore Emscripten glue
import Play from './Play';
import DiscImageDevice from "./DiscImageDevice";
// Make sure this runs before importing ./Play
;(window as any).Module = {
    locateFile: (path: string) => {
      if (path.endsWith('.wasm')) return '/Play.wasm';
      if (path.endsWith('.worker.js')) return '/Play.worker.js';
      return path;
    },
    print: console.log,
    printErr: console.error,
};
  
export let PlayModule: any = null;


let module_overrides = {
    locateFile: function(path : string) {
        const baseURL = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf( "/" ));
        return baseURL + '/' + path;
    },
    mainScriptUrlOrBlob: "/Play.js",
};

export let initPlayModule = async function() {
    module_overrides.mainScriptUrlOrBlob = module_overrides.locateFile('Play.js');
    PlayModule = await Play(module_overrides);
    PlayModule.FS.mkdir("/work");
    PlayModule.discImageDevice = new DiscImageDevice(PlayModule);
    PlayModule.ccall("initVm", "", [], []);
};
